import { ProgressionConfig } from './progressionConfig';
export const itemNames: Record<string, string> = {
    owl: 'The wise Owl', dragon_egg: 'Dragon egg',
    item_01: 'Crystal of beginnings', item_02: 'Starlight wand', item_03_clueRelic: 'Prophecy mirror',
    item_04: 'Moonlit scroll', item_05: 'The wandering hat', item_06: 'Golden spellbook', item_07: 'Chalice of wonder',
    item_08: 'Rosewater potion', item_09: 'Forest elixir', item_10: 'Dragon chalice', item_11: 'Book of secrets',
    item_12: 'Twilight lantern', item_13_blue: 'Sapphire star', item_14_blue: 'Azure rune', item_15_discovery: 'Lantern of discovery',
    item_16: 'Owl of possibility', item_17_red: 'Ruby star', item_18_red: 'Ember rune', item_19_discovery: 'Potion keeper', item_20_meta: 'Keeper of stories',
};
export const collectibles = ProgressionConfig.items.filter(item => !item.reserved);
export function itemHint(id: string): string {
    const rule = collectibles.find(item => item.id === id)?.unlock;
    if (!rule) return 'Keep exploring your world.';
    if (rule.kind === 'starsTotalAtLeast') return 'Earn ' + rule.total + ' stars in total.';
    if (rule.kind === 'tokensAtLeast') return 'Collect ' + rule.total + (rule.token === 'blueTokens' ? ' blue' : ' red') + ' tokens.';
    if (rule.kind === 'riddlesSolvedAtLeast') return 'Solve ' + rule.total + ' Owl riddles.';
    if (rule.kind === 'discovery') return 'Follow a clue and discover a hidden secret.';
    return 'A little magic is waiting for you.';
}
